import { ProductCart, showToast, useShoppingCart } from '@ecommerce/shared'
import { useCallback, useEffect } from 'react'
import useCustomizableInput from './useCustomizableInput'

export const useProductCustomization = (product: ProductCart) => {
  const { updateCustomInputsNames } = useShoppingCart()

  const { errors, setErrors, setValues, updateValue, validateAll, values: customValues } = useCustomizableInput([])

  useEffect(() => {
    if (product) {
      const newValues = Array(product.quantity).fill('')
      if (product.customUnitNames) {
        product.customUnitNames.forEach((name, index) => {
          if (index < product.quantity) {
            newValues[index] = name || ''
          }
        })
      }
      setErrors({})
      setValues(newValues)
    }
  }, [product, setValues, setErrors])

  const handleInputChange = useCallback(
    (index, value) => {
      updateValue(index, value)
    },
    [updateValue],
  )

  const handleSave = useCallback(
    (index) => {
      if (!validateAll()) {
        showToast({ content: 'Por favor, corrige los errores antes de guardar', type: 'error' })
        return
      }

      const value = customValues[index]
      if (updateCustomInputsNames && product && value && value.trim() !== '') {
        updateCustomInputsNames(product.skuCode, customValues)
        showToast({ content: 'Los textos se han guardado con éxito', type: 'success' })
      }
    },
    [product, updateCustomInputsNames, customValues, validateAll],
  )

  return {
    customValues,
    errors,
    handleInputChange,
    handleSave,
  }
}
